









import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboEtapaLead extends Vue {
  @Prop() readonly value!: string | null;
  etapaLead: ComboItem | null = null;
  readonly items: ComboItem[] = [
    { value: "", text: "" },
    { value: "0", text: "Oportunidade" },
    { value: "1", text: "Primeiro contato" },
    { value: "2", text: "Segundo contato" },
  ];

  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: () => [] }) readonly rules!: Array<
    (v: any) => string | undefined
  >;

  @Watch("value", { immediate: true })
  onValueChange(val: string | null) {
    val = "" + val;
    this.etapaLead = this.items.find((x) => x.value == val) ?? null;
  }

  @Watch("etapaLead")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }
}
